<template>
  <div class="login">
    <div class="container">
      <div class="login__wrapper">
        <login-form />
      </div>
    </div>
  </div>
</template>

<script setup>
import LoginForm from "@/components/forms/login-form.vue";
</script>

<style lang="scss" scoped>
.login {
  background-image: url(@images/authBg.png);
  background-repeat: no-repeat;
  background-size: cover;

  &__wrapper {
    padding-block: 100px 175px;
    display: grid;
    place-items: center;
  }
}
</style>